//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { openWordStudy } from '@/utils/openWordStudy'
export default {
  data () {
    return { items: [], idx: 0, showAns: false, details: [], start: Date.now(), correct: 0, wrong: 0 }
  },
  computed: { cur () { return this.items[this.idx] } },
  created () {
    this.$ajax.get(this.$api.mpReviewStart + '?palace_id=' + this.$route.query.id + '&mode=roam').then(r => {
      this.items = (r && r.items) || []
      if (!this.items.length) this.$toast && this.$toast('请先绑定单词')
    })
  },
  methods: {
    study () {
      const cur = this.cur
      if (!cur) return
      openWordStudy(this.$router, cur.word || cur.word_text || cur.wordText)
    },
    rate (result) {
      const cur = this.cur
      this.$ajax.post(this.$api.mpReviewSubmit, { anchor_id: cur.id, result }).catch(() => {})
      this.details.push({ anchor_id: cur.id, word_id: cur.word_id || cur.wordId, result })
      if (result === 1) this.correct++; else if (result === 3) this.wrong++
      this.showAns = false
      if (this.idx >= this.items.length - 1) this.finish(); else this.idx++
    },
    finish () {
      const body = {
        palace_id: this.$route.query.id,
        review_mode: 'roam',
        duration: Math.round((Date.now() - this.start) / 1000),
        details: this.details
      }
      this.$ajax.post(this.$api.mpReviewFinish, body).then(r => {
        this.$router.replace({ path: '/mpResult_display', query: { record_id: r.record_id } })
      })
    },
    exit () { this.$router.replace({ path: '/mpDetail_display', query: { id: this.$route.query.id } }) }
  }
}



// WEBPACK FOOTER //
// ./src/views/innovation/memory-palace/roam.vue